// src/pages/B2B/event-reports/pdf/warm/sections/WarmHero.tsx
import React from 'react';
import { formatTzWindow } from '../../../utils/formatTzWindow';

interface Props {
  eventName: string;
  fromLocal: string;
  toLocal: string;
  timezone: string;
  locationLabel: string;
  imageDataUrl: string | null;
}

export function WarmHero(props: Props): React.ReactElement {
  const { eventName, fromLocal, toLocal, timezone, locationLabel, imageDataUrl } = props;
  const win = formatTzWindow(fromLocal, toLocal, timezone);
  return (
    <header className="hero">
      <div className="hero-inner">
        <div>
          <span className="kicker"><span className="dot"></span>Bar-crawl report</span>
          <h1>{eventName || 'Event Recap'}</h1>
          <p className="subtitle">
            {win}{locationLabel ? ` · ${locationLabel}` : ''}
          </p>
        </div>
        {imageDataUrl && (
          <div className="hero-art">
            <img src={imageDataUrl} alt="" />
          </div>
        )}
      </div>
    </header>
  );
}
